import Track from "webPage/Track";

export default function handleConsultantsHeaderSliderBlocks() {
    let $imagesSlider = $(".js-images-slider");
    if ($imagesSlider.length > 0) {
        $imagesSlider.each(function () {
            let slider = new Track($(this), {
                classes: {
                    block: "slider",
                },
            });

            slider.on('buttons', (data) => {
                if (data.forwards) {
                    slider.$element.addClass('slider--has-forward');
                }

                if (data.backwards) {
                    slider.$element.addClass('slider--has-back');
                }
            });

            $(window).on('load resize', function(){
                let itemsTotalWidth = slider.getTotalItemsSize();
                let sliderWidth = slider.$element.outerWidth();

                if(sliderWidth < itemsTotalWidth){
                    slider.enable();
                    slider.$element.removeClass('slider--disabled').addClass('slider--has-forward slider--has-back');
                }
            });
        });
    }
}
